/**
* @author Akhila
* @email 83606@global.ul.com
* @create date 2020-08-28 15:52:48
* @modify date 2020-08-28 15:52:48
* @desc Dashboard layout
*/
<template>
  <div>
    <template v-if="isDataAvailable === true">
      <expiry-popup :projectExpirationList="projectExpirationList" :serviceExpirationList="serviceExpirationList"  :expiryAddOnList="expiryAddOnList" :roleId="roleId" :account_id="account_id" :userId="userId"></expiry-popup>
    </template>
    <template v-if="displayDashboard == 'default'">
      <default-dashboard
        :isDashboardNotification="isDashboardNotification"
        :isDashboardCustomizable="isDashboardCustomizable"
        :roleId="roleId"
        :account_id="account_id"
        :userId="userId"
        :isDefault="isDefault"
      >
      </default-dashboard>
    </template>
    <template v-if="displayDashboard === 'customized'">
      <customized-dashboard :isDefault="isDefault"></customized-dashboard>
    </template>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import {
  isDefaultDashboard,
  displayNotification,
  getNotificationTypes,
  isDashboardCustomizable,
} from '../../apis/dashboardCustomization';
import { getExpiryDismissServices } from '../../apis/notification';
import Loader from '../UIComponents/Loader.vue';
import DefaultDashboard from './Dashboard.vue';
import CustomizedDashboard from './CustomizeDashboard.vue';
import ExpiryPopup from './ExpiryPopup.vue';
import EventBus from '../../utils/event-bus';
import { getSBExpiringProjects } from '../../apis/submissionBuilder';

export default {
  name: 'DashboardLayout',
  components: {
    DefaultDashboard,
    CustomizedDashboard,
    Loader,
    ExpiryPopup,
  },
  props: {
    account_id: Number,
    roleId: Number,
    userId: Number,
  },
  data() {
    return {
      isDashboardNotification: null,
      loaderStatus: false,
      isDefault: null,
      displayDashboard: '',
      notiTypes: [],
      isDashboardCustomizable: false,
      projectExpirationList: [],
      serviceExpirationList: [],
      expiryAddOnList: [],
      isDataAvailable: false,
      closeClicked: false,
    };
  },
  computed: {
  },
  watch: {
    async $route() {
      if (this.$route.params.initializePage) {
        await this.initialize();
      }
    },
  },
  methods: {
    async initialize() {
      this.loaderStatus = true;
      await Promise.all([
        this.isDefaultDashboard(),
        this.checkDashboardCustomizable(),
        this.getNotificationTypes(),
        this.displayNotification(),
        this.getExpiryServices(),
        this.getSBExpiringProjects(),
      ]);
      this.loaderStatus = false;
    },
    async getExpiryServices() {
      const response = await getExpiryDismissServices(JSON.parse(localStorage.getItem('userData')).account_id, JSON.parse(localStorage.getItem('userData')).id);
      this.serviceExpirationList = [];
      this.expiryAddOnList = [];
      let expirationList = [];
      if (response.data.plan && response.data.plan.length > 0) {
        expirationList = response.data.plan;
      }
      if (response.data.add_on && response.data.add_on.length > 0) {
        this.expiryAddOnList = response.data.add_on;
      }
      const userData = JSON.parse(localStorage.getItem('userData'));
      for (let i = expirationList.length - 1; i >= 0;) {
        if (userData.account_type_id === 2 && (expirationList[i].name === 'Regulatory Watch' || expirationList[i].name === 'Registration Tracker' || expirationList[i].name === 'Regulatory Intelligence' || expirationList[i].name === 'Product Classification')) {
          expirationList.splice(i, 1);
        }
        i -= 1;
      }
      this.serviceExpirationList = expirationList;
      this.isDataAvailable = false;
      if (this.serviceExpirationList.length > 0 || this.expiryAddOnList.length > 0 || this.projectExpirationList.length > 0) {
        this.isDataAvailable = true;
      }
    },
    async getSBExpiringProjects() {
      this.loaderStatus = true;
      const response = await getSBExpiringProjects(this.account_id);
      if (response && response.length) {
        response.forEach((each) => {
          const obj = {
            expiry_date: each.expiresAt,
            id: 3,
            name: `Smart Builder Project - ${each.name}`,
          };
          this.projectExpirationList.push(obj);
        });
      }
      if (this.serviceExpirationList.length > 0 || this.projectExpirationList.length > 0 || this.expiryAddOnList.length > 0) {
        this.isDataAvailable = true;
      }
      this.loaderStatus = false;
    },
    async checkDashboardCustomizable() {
      this.isDashboardCustomizable = await isDashboardCustomizable(JSON.parse(localStorage.getItem('userData')).account_id, JSON.parse(localStorage.getItem('userData')).role_id);
    },
    async getNotificationTypes() {
      this.notiTypes = await getNotificationTypes();
    },
    async isDefaultDashboard() {
      this.isDefault = await isDefaultDashboard(JSON.parse(localStorage.getItem('userData')).account_id, JSON.parse(localStorage.getItem('userData')).id);
      if (this.isDefault) {
        this.displayDashboard = 'default';
      } else {
        this.displayDashboard = 'customized';
      }
    },
    async displayNotification() {
      const notification = await displayNotification(JSON.parse(localStorage.getItem('userData')).account_id, JSON.parse(localStorage.getItem('userData')).id);
      if (notification && notification.notification_type_id != null) {
        this.isDashboardNotification = this.notiTypes.find((item) => item.id === notification.notification_type_id);
      } else {
        this.isDashboardNotification = null;
      }
    },
  },
  async mounted() {
    await this.initialize();
    EventBus.$on('initializePage', async (data) => {
      if (data) {
        await this.initialize();
      }
    });
    EventBus.$on('closeOnProdClassClicked', (clickFlag) => {
      this.closeClicked = clickFlag;
    });
  },
};
</script>
<style scoped>

</style>
